import useLangTranslation from "./languageProvider";

function useDurationOption() {
  const { getLangTranslation } = useLangTranslation();
  function durationOptionsFunction() {
    return [
      {
        label: getLangTranslation("CHILD_LOCATION_TODAY", "Today"),
        value: 1,
      },
      {
        label: getLangTranslation("WEB_ACTIVITY_FILTER_7_DAYS", "7 Days"),
        value: 2,
      },
      {
        label: getLangTranslation("WEB_ACTIVITY_FILTER_14_DAYS", "14 Days"),
        value: 3,
      },
      {
        label: getLangTranslation("WEB_ACTIVITY_FILTER_30_DAYS", "30 Days"),
        value: 4,
      },
      {
        label: getLangTranslation("Custom", "Custom"),
        value: 5,
      },
    ];
  }

  function daysAndWeekFunction() {
    return [
      { value: "EVERYDAY", label: getLangTranslation("EVERYDAY", "Every day") },
      { value: "WEEKDAYS", label: getLangTranslation("WEEKDAYS", "Weekdays") },
      { value: "WEEKEND", label: getLangTranslation("WEEKEND", "Weekend") },
      {
        value: "MONDAY",
        label: getLangTranslation(
          "TIME_SUPERVISION_SET_SCHEDULE_MONDAY",
          "Monday"
        ),
      },
      {
        value: "TUESDAY",
        label: getLangTranslation(
          "TIME_SUPERVISION_SET_SCHEDULE_TUESDAY",
          "Tuesday"
        ),
      },
      {
        value: "WEDNESDAY",
        label: getLangTranslation(
          "TIME_SUPERVISION_SET_SCHEDULE_WEDNESDAY",
          "Wednesday"
        ),
      },
      {
        value: "THURSDAY",
        label: getLangTranslation(
          "TIME_SUPERVISION_SET_SCHEDULE_THURSDAY",
          "Thursday"
        ),
      },
      {
        value: "FRIDAY",
        label: getLangTranslation(
          "TIME_SUPERVISION_SET_SCHEDULE_FRIDAY",
          "Friday"
        ),
      },
      {
        value: "SATURDAY",
        label: getLangTranslation(
          "TIME_SUPERVISION_SET_SCHEDULE_SATURDAY",
          "Saturday"
        ),
      },
      {
        value: "SUNDAY",
        label: getLangTranslation(
          "TIME_SUPERVISION_SET_SCHEDULE_SUNDAY",
          "Sunday"
        ),
      },
    ];
  }

  function categoryOptionsFunction() {
    return [
      {
        label: getLangTranslation(
          "APP_MONITORING_CATEGORY_LIST_FILTER_ALL_CATEGORIES",
          "All Categories"
        ),
        value: "ALL",
      },
      {
        label: getLangTranslation(
          "APP_MONITORING_CATEGORY_LIST_FILTER_ALLOWED",
          "Allowed"
        ),
        value: "ALLOW",
      },
      {
        label: getLangTranslation(
          "APP_MONITORING_CATEGORY_LIST_FILTER_BLOCKED",
          "Blocked"
        ),
        value: "BLOCK",
      },
      {
        label: getLangTranslation(
          "APP_MONITORING_CATEGORY_LIST_FILTER_WARNED",
          "Warned"
        ),
        value: "WARN",
      },
    ];
  }

  function appCategoryOptionFunction() {
    return [
      {
        label: getLangTranslation("APP_MONITORING_APP_LIST_FILTER_ALL", "All"),
        value: "ALL",
      },
      {
        label: getLangTranslation(
          "APP_MONITORING_APP_LIST_FILTER_ALLOWED",
          "Allowed"
        ),
        value: "ALLOW",
      },
      {
        label: getLangTranslation(
          "APP_MONITORING_APP_LIST_FILTER_BLOCKED",
          "Blocked"
        ),
        value: "BLOCK",
      },
      {
        label: getLangTranslation(
          "APP_MONITORING_APP_LIST_FILTER_WARNED",
          "Warned"
        ),
        value: "WARN",
      },
    ];
  }

  function hourMinOptionFunction() {
    return [
      { label: getLangTranslation("SCREENSHOTS_MIN", "Minute"), value: "MIN" },
      {
        label: getLangTranslation("SCREENSHOTS_HOUR", "Hour"),
        value: "HRS",
      },
    ];
  }

  function statusOptionFunction() {
    return [
      { label: getLangTranslation("PARENT_TASK_FILTER_ALL", "All"), value: "" },
      {
        label: getLangTranslation("PARENT_TASK_BUTTON_PENDING", "Pending"),
        value: 0,
      },
      { label: getLangTranslation("CONFIRMED", "Confirmed"), value: 1 },
      {
        label: getLangTranslation("FINISHED", "Finished"),
        value: 2,
      },
    ];
  }

  return {
    durationOptionsFunction,
    daysAndWeekFunction,
    categoryOptionsFunction,
    appCategoryOptionFunction,
    hourMinOptionFunction,
    statusOptionFunction,
  };
}

export default useDurationOption;
